<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
    <g clip-path="url(#clip0_3794_20519)">
      <path
        d="M15.2074 8.29492H13.7499V3.71159C13.7499 3.20742 13.3374 2.79492 12.8333 2.79492H9.16658C8.66242 2.79492 8.24992 3.20742 8.24992 3.71159V8.29492H6.79242C5.97659 8.29492 5.56409 9.28492 6.14158 9.86242L10.3491 14.0699C10.7066 14.4274 11.2841 14.4274 11.6416 14.0699L15.8491 9.86242C16.4266 9.28492 16.0233 8.29492 15.2074 8.29492ZM4.58325 17.4616C4.58325 17.9658 4.99575 18.3783 5.49992 18.3783H16.4999C17.0041 18.3783 17.4166 17.9658 17.4166 17.4616C17.4166 16.9574 17.0041 16.5449 16.4999 16.5449H5.49992C4.99575 16.5449 4.58325 16.9574 4.58325 17.4616Z"
        fill="#3B755F"
      />
    </g>
    <defs>
      <clipPath id="clip0_3794_20519">
        <rect width="22" height="22" fill="white" transform="translate(0 0.0449219)" />
      </clipPath>
    </defs>
  </svg>
</template>
